module.exports = __webpack_public_path__ + "img/BlackVault.ea608abf.png";